import { useState } from "react";

function ProductScreenCard({ item, index }) {
  const [imageAvailable, setImageAvailable] = useState(true);

  return (
    <article
      className={`product-screen-card ${
        index % 2 === 1 ? "product-screen-card-reverse" : ""
      }`}
    >
      <div className="product-screen-copy">
        <span className="product-screen-number">
          {String(index + 1).padStart(2, "0")}
        </span>

        <h3>{item.title}</h3>
        <p>{item.text}</p>

        {item.highlights?.length > 0 && (
          <ul className="product-screen-highlights">
            {item.highlights.map((highlight) => (
              <li key={highlight}>{highlight}</li>
            ))}
          </ul>
        )}
      </div>

      <div className="product-screen-visual">
        {imageAvailable ? (
          <img
            src={item.image}
            alt={item.alt || item.title}
            loading="lazy"
            onError={() => setImageAvailable(false)}
          />
        ) : (
          <div className="product-screen-placeholder">
            <span className="product-screen-placeholder-icon">▣</span>
            <strong>{item.title}</strong>
            <small>{item.placeholder || "Screen preview"}</small>
          </div>
        )}
      </div>
    </article>
  );
}

export default function ProductScreens({ data }) {
  if (!data?.items?.length) {
    return null;
  }

  return (
    <section className="section product-screens" id="product-screens">
      <div className="section-head product-screens-head">
        <p className="eyebrow">{data.eyebrow}</p>
        <h2>{data.title}</h2>
        <p>{data.text}</p>
      </div>

      <div className="product-screen-list">
        {data.items.map((item, index) => (
          <ProductScreenCard
            key={item.title}
            item={{
              ...item,
              placeholder: data.placeholder
            }}
            index={index}
          />
        ))}
      </div>
    </section>
  );
}
